import { api } from './api';

export const fetchPrivileges = (id) => {
  return api.get(`/user/${id}/privileges`);
};

export const fetchUserOrganizations = (params) => {
  return api.get('/user/organizations', params);
};

export const createUser = (data) => {
  return api.post('/user', data);
};
